<script>
    import Header from '../header.svelte';
	import { api_host, subdomain_manager,bpm_domain, user_store } from '../../stores.js';
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { toast_message } from '../../utils/toast_message.js';
    import { handle_not_subscribed } from '../../utils/format.js';
    import Swal from "sweetalert2";
    import { querystring, push, replace, location } from 'svelte-spa-router';
    import { onMount } from 'svelte';
    import { trial_domain_suffix } from '../../globals';


    const { auth_type, auth_token, domain_code } = getToken();
    
    let is_domain_able = undefined;
    let subdomain_editing = false;
    let original_subdomain = '';
	let subdomain = '';
    let myself = {};
    let is_busy;
    let is_new_user = false;
    let previous_location = '';

    user_store.subscribe(value => {
        myself = value;
    });

    subdomain_manager.subscribe(value => {
        console.log(value, "===");
        original_subdomain = value;
        subdomain = myself.is_trial ? value.replace(trial_domain_suffix, '') : value;
    });

    // Check domain status when component becomes active
    function checkDomainAndShowPopup() {
        if (!original_subdomain || original_subdomain.trim() === 'sample') {
            setTimeout(() => {
                Swal.fire({
                    title: "Click 'Edit,' then enter your website domain.",
                    confirmButtonText: 'Ok',
                    icon: "info"
                });
            }, 300);
        }
    }

    onMount(() => {
        previous_location = $location;
        const params = new URLSearchParams($querystring);
        if (params.has("is_new_user")) {
            is_new_user = true;
            toast_message(true, "Enter your company domain", 3000);
        }
        // Check on initial mount
        checkDomainAndShowPopup();
    });

    // Check when location changes to this page (user navigates via menu)
    $: if ($location !== previous_location && $location.includes('Settingsdomain')) {
        previous_location = $location;
        checkDomainAndShowPopup();
    }
    $: {
        if (subdomain.includes(trial_domain_suffix)) {
            subdomain.replace(trial_domain_suffix, '');
        }
    }
</script>

<Header title="Settings - Domain" bind:is_busy={is_busy} />

<div class="subdomain-container">
	<span>Subdomain:&nbsp;</span>
	<div class="input-group suffix">                           
		<input
            type="text"
            name="input"
            bind:value={subdomain}
            disabled={!subdomain_editing}
            on:input={(evt) => {
                const subdomain_check = /^[a-zA-Z0-9-]+[a-zA-Z0-9]$/;
                is_domain_able = true;
                if (!evt.target['value'].match(subdomain_check)) {
                    is_domain_able = false;
                }
            }}
        />
	   	<span class="input-group-addon">{myself.is_trial ? trial_domain_suffix : ''}.{bpm_domain}</span>
	</div>
</div>
{#if !is_domain_able && is_domain_able !== undefined}
    <span style='color: red;margin-left: 5px;font-size: 13px;'>Incorrect domain name</span>
{/if}
<span style="display: block;">
    My Domain: <a href={`https://${subdomain}${myself.is_trial ? trial_domain_suffix : ''}.${bpm_domain}`} style="margin-left: 10px;" target="_blank">
        {subdomain}{myself.is_trial ? trial_domain_suffix : ''}.{bpm_domain}
    </a>
</span>
<br />

{#if myself.role !== 'manager'}
    <button disabled={is_domain_able === false} on:click={async () => {
        if (myself['is_subscribed'] !== undefined && !myself['is_subscribed']) {
            handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
            return;
        }
        if (subdomain_editing) {
            Swal.fire({
                title: "Update domain link?",
                confirmButtonText: 'OK',
                cancelButtonText: "Cancel",
                showCancelButton: true,
                icon: "success"
            }).then(async (e) => {
                if (e.isConfirmed) {
                    is_busy = true;
                    let param_subdomain = `${subdomain}${myself.is_trial ? trial_domain_suffix : ''}`;
                    const res = await doFetch(
                        api_host + `/api/domain/set`,
                        'POST',
                        { domain_name: `${param_subdomain}.${bpm_domain}`, subdomain },
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    if (res.status) {
                        toast_message(true, res.msg, 2000);
                        if (is_new_user) {
                            setTimeout(() => {
                                push('#/Contenthomepage?is_new_user=true');
                            }, 1000);
                        }
                    } else {
                        subdomain = original_subdomain;
                        toast_message(false, res.msg || 'Domain set failed', 2000);
                    }
                    subdomain_manager.set(param_subdomain);
                    is_busy = false;
                } else {
                    subdomain = original_subdomain;
                }
            });
        }
        subdomain_editing = !subdomain_editing;
    }}>
        {subdomain_editing ? 'Save' : 'Edit'}
    </button>
{/if}
{#if subdomain_editing}
<button on:click={() => {
    subdomain_editing = false;
    subdomain = original_subdomain;
    is_domain_able = true;
}}>Cancel</button>
{/if}

<style>
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
.subdomain-container {
    margin-top: 15px;
	display: flex;
	place-items: center;
}
.input-group-addon {
    padding: 6px 12px;
    font-size: 14px;
    font-weight: 400;
    line-height: 1;
    color: #555;
    text-align: center;
    background-color: #eee;
    border: 1px solid #ccc;
    width: 1%;
    white-space: nowrap;
    vertical-align: middle;
    display: table-cell;
}
input {
	text-align: right;
    position: relative;
    z-index: 2;
    float: left;
    width: 100%;
    margin-bottom: 0;
    display: table-cell;
    padding: 6px 12px;
    border: 1px solid #ccc;
    margin: 0;
}
.suffix input {
    border-radius: 4px 0px 0px 4px;
}
.suffix .input-group-addon {
    border-left: 0;
    border-radius: 0px 4px 4px 0px;
}
.input-group {
	width: 500px;
    position: relative;
    display: table;
    border-collapse: separate;
}
</style>